import { render, staticRenderFns } from "./ClassicMultiversalDimensionRow.vue?vue&type=template&id=4c8aa071&scoped=true&"
import script from "./ClassicMultiversalDimensionRow.vue?vue&type=script&lang=js&"
export * from "./ClassicMultiversalDimensionRow.vue?vue&type=script&lang=js&"
import style0 from "./ClassicMultiversalDimensionRow.vue?vue&type=style&index=0&id=4c8aa071&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8aa071",
  null
  
)

export default component.exports